export class LevelAlerte {
  public static readonly DEBUG = 0;
  public static readonly INFORMATIONAL = 1;
  public static readonly NOTICE = 2;
  public static readonly WARNING = 3;
  public static readonly ERROR = 4;
  public static readonly CRITICAL = 5;
  public static readonly ALERT = 6;
  public static readonly EMERGENCY = 7;

  public static export(level: LevelAlerte): string {
    switch (level) {
      case LevelAlerte.DEBUG:
        return 'debug';
      case LevelAlerte.INFORMATIONAL:
        return 'informational';
      case LevelAlerte.NOTICE:
        return 'notice';
      case LevelAlerte.WARNING:
        return 'warning';
      case LevelAlerte.ERROR:
        return 'error';
      case LevelAlerte.CRITICAL:
        return 'critical';
      case LevelAlerte.ALERT:
        return 'alert';
      case LevelAlerte.EMERGENCY:
        return 'emergency';
    }
    return 'emergency';
  }
}
